<template>
	<div class="backend-left-nav">
		<img src="../../assets/logo.svg" class="logo" alt="">
		<el-collapse v-model="activeNames">
			<el-collapse-item title="官網頁面上稿" name="1">
				<div v-for="(route, i) in officialRouter" :key="i">
					<router-link :to="{name: route.name}">{{route.label}}</router-link>
				</div>
			</el-collapse-item>
			<el-collapse-item title="挑戰平台後台" name="2">
				<div v-for="(route, i) in challengeRouter" :key="i">
					<router-link :to="{name: route.name}">{{route.label}}</router-link>
				</div>
			</el-collapse-item>
		</el-collapse>
		<div class="logout-btn button-tp color-white bg-text3" @click="logout">登出</div>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
	data() {
		return {
			activeNames: ["1", "2"],
		};
	},
	computed: {
		...mapState('user', ['userInfo']),
		...mapState('manager', ['challengeRoutes', 'officialRoutes']),
		officialRouter() {
			if (this.userInfo.role == 'admin') {
				return this.formatRoute(this.officialRoutes);
			}
			return this.formatRoute(this.userInfo.official_routes);
		},
		challengeRouter() {
			if (this.userInfo.role == 'admin') {
				return this.formatRoute(this.challengeRoutes);
			}
			return this.formatRoute(this.userInfo.challenge_routes);
		},
	},
	methods: {
		...mapActions(["managerLogout"]),
		formatRoute(routes = []) {
			return routes.map(route => {
				return {
					label: route.label,
					name: route.value
				}
			});
		},
		logout() {
			this.managerLogout();
		}
	},
	created() { },
	mounted() { },
	components: {}
};
</script>

<style lang="scss" scoped>
.backend-left-nav {
	width: 170px;
	margin-right: 20px;

	img {
		width: 100%;
		margin-bottom: 10px;
	}

	.is-active {
		border-radius: 5px;
		background-color: #60adf5;
		color: white;
	}

	.logout-btn {
		height: 30px;
		margin-top: 15px;
	}
}
</style>